"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useValidation = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
var web3_1 = __importDefault(require("web3"));
var _pool_1 = require("../../../pool");
var utils_1 = require("../../../shared/utils");
function useValidation(_a) {
    var userCurrencyBalance = _a.userCurrencyBalance, userCurrencyContribution = _a.userCurrencyContribution, currencyValue = _a.currencyValue, tokenValue = _a.tokenValue, tierAllocation = _a.tierAllocation, tokensBalance = _a.tokensBalance, wholeTokens = _a.wholeTokens;
    var sale = (0, _pool_1.usePoolSale)()[0];
    var currencyError;
    try {
        var wei = getWei(currencyValue);
        currencyError = validateCurrencyValue({
            wei: wei,
            userBalance: userCurrencyBalance,
            userContribution: userCurrencyContribution,
            min: sale.limits.min,
            max: tierAllocation ? null : sale.limits.max,
        });
    }
    catch (e) {
        currencyError = e.toString();
    }
    var tokensLeft = sale.tokensForSale.sub(sale.tokensSold);
    var tokenError;
    try {
        var wei = getWei(tokenValue);
        tokenError = validateTokenValue({
            wei: wei,
            tokensLeft: tokensLeft,
            balance: tokensBalance,
            max: tierAllocation,
            wholeTokens: wholeTokens,
        });
    }
    catch (e) {
        tokenError = e.toString();
    }
    return {
        currencyError: currencyError,
        tokenError: tokenError,
    };
}
exports.useValidation = useValidation;
function getWei(value) {
    try {
        return new bn_js_1.default(web3_1.default.utils.toWei(value));
    }
    catch (e) {
        throw "Invalid value";
    }
}
function validateCurrencyValue(_a) {
    var wei = _a.wei, userBalance = _a.userBalance, userContribution = _a.userContribution, min = _a.min, max = _a.max;
    if (min && min.gtn(0) && wei.lt(min)) {
        return "Contribution is too small";
    }
    // more than max or (max - already contributed)
    if (max && max.gtn(0) && userContribution.add(wei).gt(max)) {
        return;
        // return "Contribution is too big";
    }
    if (wei.gt(userBalance)) {
        throw new Error("Not enough funds");
    }
}
function validateTokenValue(_a) {
    var wei = _a.wei, tokensLeft = _a.tokensLeft, balance = _a.balance, max = _a.max, wholeTokens = _a.wholeTokens;
    if (wei.gt(tokensLeft)) {
        return "Not enough tokens left";
    }
    if (max && max.gtn(0) && balance.add(wei).gt(max)) {
        // return "Contribution is too big";
        return;
    }
    var wholeValue = (0, utils_1.toWeiBN)(Math.floor((0, utils_1.toEthN)(wei)));
    if (wholeTokens && wei.sub(wholeValue).gtn(0)) {
        return "Can buy only whole tokens";
    }
}
